'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var resources = function resources() {
  return import('@/page/resources');
};

exports.default = [{
  path: '/resources',
  name: 'resources',
  component: resources
}];